import { useInvalidateCurrentUser, useGetUserInfo } from './user-info';

export const useGetWebcoins = () => {
  const { data: userInfo, isLoading } = useGetUserInfo();

  return {
    amount: userInfo?.webCoin,
    isLoading,
  };
};

export const useInvalidateBalance = () => {
  return useInvalidateCurrentUser();
};

export const useGetClubCoins = () => {
  const { data: userInfo, isLoading } = useGetUserInfo();
  return {
    amount: userInfo?.clubCoin,
    isLoading,
  };
};

export const useGetRuby = () => {
  const { data: userInfo, isLoading } = useGetUserInfo();
  return {
    amount: userInfo?.ruby,
    isLoading,
  };
};
